module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_c('em', [_vm._v("Six")])])]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Ben English was in good spirits as he and his partner pulled up to the gates of Ariel Simmons’s estate on the south edge of Dallas. Red pointed to the massive iron angels on either side of the entrance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Unless she’s got one hell of an explanation for the picture of her that we found in Finelli’s apartment, she’s going to be needing more than two of those fellows,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben shrugged as he pressed the button on the call box.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe it was just a poor choice of Halloween costumes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Red grinned. “Black leather, a whip and iron spikes, maybe… but I don’t think that man in manacles was part of the costume.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben nodded. “Yeah, and if Finelli hadn’t written her name on the back of the photo, chances are we would never have been able to identify her. Looks a damn sight different than the slender blonde angel who appears on television four nights a week.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The iron gates swung open.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_102"
    }
  }), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("“So let’s go talk to the angel and see what she has to say for herself,” Red said.")])]), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben put the car in gear and drove through. Yet when they were ushered into Ariel Simmons’s living room by a uniformed maid, their perception of her changed again. The room was all crystal and steel, with sharp angles in the furniture and freeform sculptures that made no sense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Man,” Red muttered. “What do you make of this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben stood with his hands in his pockets as his gaze jumped from one comer of the room to the other, and while he would have been the first person to agree that taste was subjective, the first word that came to mind was, "), _c('em', [_vm._v("wasteland")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It looks like the set of a bad sci-fi movie,” Ben said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gentlemen, how may I help you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman’s voice was startling in its clarity and power. They turned toward the sound, facing the tall, angular woman silhouetted in the doorway. Her white-blonde hair was shorter than Red’s. Pale-blue leggings accentuated her shapely legs, while the embroidery at the hem of her poet’s shirt brushed the tops of her knees. Blue ballerina shoes covered her feet, and a bulky gold chain served as a belt, molding the shirt to a very small waist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben flashed his badge. “Detective Bennett English, Homicide. This is my partner, Detective Fisher.” Red offered his badge as identification, too.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_103"
    }
  }), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("As Ariel walked toward them, Ben tried to superimpose the woman in Chaz Finelli’s picture onto her face and couldn’t quite make the connection. Had they made a mistake?")])]), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, Detectives, to what do I owe the pleasure?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe you’d like to sit,” Ben said. “This may take a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ariel smiled and glided past them, moving like a dancer across a stage. When she sat, Ben was aware that, once again, she seemed to be playing a part.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right, I’m sitting,” she said. “Now, how can I help you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben sat on the sofa directly across from her chair and then laid the picture on the table between them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Explain this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If he hadn’t been watching her so closely, he might have missed the look of shock that came and went in her eyes, because when she looked up, her expression was suitably disgusted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A woman in need of God,” Ariel said, and touched the picture with the flat of her hand. “Tell me her name, Detective English, and I will pray for her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Red shifted nervously beside Ben and gave him a questioning glance, but Ben knew her poise had been shaken.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“According to Charles Finelli’s files, her name is Ariel Simmons.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("Ariel gasped and clasped both hands to the sides of her face. “Have mercy!” she cried. “Surely you gentlemen ")]), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("could not believe that lascivious woman is me? You know my truth. You know God is love.”")])]), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Actually, Miss Simmons, we don’t know your truth, which is why we’re here. Now can you tell us where you were around 10:00 p.m. on December 11?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was on television. Check your listings,” Ariel said, then stood abruptly and sailed past them to a phone on a nearby table. Angrily, she punched in a series of numbers. As she waited for someone to answer, she turned toward the men, giving them a fairly good rendition of a woman wronged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look, Ben,” Red muttered, “the captain will have our hides if we tick off the religious right on this case. Maybe it isn’t her. After all, that woman in the picture has dark hair.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Ben didn’t answer. He was too busy watching Ariel Simmons’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Langley, I need you,” Ariel said. “It’s an emergency. Something terrible is happening—just terrible. I’m about to be slandered, and I want protection. Yes, just get over here as soon as you can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She hung up with a flourish and then pointed toward the door, something Scarlett O’Hara might have done in banishing Rhett Butler from her life. It was all a little too exaggerated for Ben to believe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gentlemen, I believe you can find your way out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben shook his head. “Not until you answer a couple more questions.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t have to answer anything. I know my rights, and I will not be blackmailed by some—”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_105"
    }
  }), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("Ben moved, pinning Ariel between his glare and the front of her desk. He kept thinking of the woman who’d come so close to death last night, and of the baby she’d lost. Even Charles Finelli, as low as he was, hadn’t deserved to be gunned down in the street like a gutter rat.")])]), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“This isn’t blackmail, lady, it’s murder,” Ben said. “Now you can talk to us here, or you can come down to the station. Either way, you "), _c('em', [_vm._v("will")]), _vm._v(" talk to us until we’re satisfied with your answers or we decide you’re lying. In which case you "), _c('em', [_vm._v("will")]), _vm._v(" be needing that lawyer you called when we read you your rights.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ariel paled. Her eyes darted from one man to the other. Ben imagined he could see the wheels turning as she decided how to play her next scene. Suddenly she became teary-eyed and bowed her head as if humiliated and shamed, then staggered back to her chair before sinking into its depths.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, so sorry, but you must understand. This was such a shock. Of course that sinful woman is not me. I preach God’s message, not Satan’s. I’ll help you if I can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re quite different in person from the woman on TV,” Ben said. “Your hair is short, and your clothes are nothing like the gowns that you wear on your show.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("Ariel gave him a tremulous smile. “Praise God, dear sir. If you’ve seen my broadcasts, then you have heard the Word. Of course, my image is all important. But I make so many public appearances that it becomes difficult ")]), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_vm._v("to maintain a perfect coiffure, so I wear wigs. I have several, you know. As for the gowns, well…”")])]), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All part of the image, right?” Ben said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She nodded and sighed, then leaned over and pulled a tissue from a box before using it to blot her tears.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you know Charles Finelli?” Red asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ariel was a little startled when the question came at her from another source, and again Ben saw her composure slip, but it was so fleeting it almost escaped him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry… what was that name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Finelli. Charles Finelli.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I can’t say that I do,” Ariel said. “But I meet so many people in my ministry. If you had a picture…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben pulled one out of his pocket and dropped it in her lap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Dear Lord!” Ariel gasped, and covered her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was the one of Finelli lying in the street after he’d been shot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The poor man. And you say he was murdered?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He was also a blackmailer,” Ben added. “According to the files he kept, a very successful one. How much did you pay him for the pictures he took of you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ariel’s eyes narrowed as, once again, her saintly countenance began to fade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Again I tell you that woman is not me, nor did I pay any money to Chaz Finelli.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_107"
    }
  }), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_vm._v("Ben went still. He could feel Red looking at him, but he wouldn’t take his eyes off Ariel’s face. He leaned down, bracing himself with a hand on either arm of her chair. Her breath was warm against his face as he spoke.")])]), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“A few more questions, and then we’ll be gone,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looked up, meeting his gaze head-on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought you didn’t know the murder victim,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right, I don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you called him Chaz. Only the people who knew him best called him by that name, and since I didn’t tell you that little bit of information, I’m inclined to believe you’ve been lying.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All the blood drained from Ariel Simmons’s face. Her eyes widened in fear as her lips went slack.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And there’s something else you should know,” Ben said softly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wh-wh-what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t like being lied to. Did you have Charles Finelli killed?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, and I don’t care what you like,” she blustered. “Now get away from me before I call the police.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben smiled, and it was not a pretty smile as he waved the picture of Finelli beneath her nose. “We "), _c('em', [_vm._v("are")]), _vm._v(" the police, and if I find out you’re responsible for this, all the prayers in heaven will not save your lying ass. Do we understand each other?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get out,” she muttered.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_108"
    }
  }), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_vm._v("Ben straightened. “Don’t leave town,” he said. “Don’t bother to get up. We’ll see ourselves out.”")])]), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Once they were outside, Red took a deep breath and then scratched his head as he looked at Ben’s angry face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think that went well,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just get in the car,” Ben muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("***")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("For the first time in days, China was physically aware of her surroundings. She felt pain. She felt cold. She felt the nurses’ hands as they ministered to her needs. Sometimes she even understood what they were saying, but the flashes of cognizance didn’t last. Her awareness would fade with the onset of a fresh wave of pain, or from the contents of a hypodermic syringe being administered intravenously. Each time she started going under, there was a part of her that resisted. She kept remembering that voice promising to help find her baby’s killer, and all she had to do was wake up. If she didn’t, the man behind the voice might forget, and if he did, it would be the end of any hope of justice. She knew they would never find the person responsible for the shootings, because they were looking for a man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She struggled with the thought, but the sedative was too strong and her pain was too sharp, so she let herself slide into oblivion—one more time.")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("***")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("“Where in hell did you get that?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_vm._v("Ben put the picture he’d just shown country singer ")]), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_vm._v("Larry Dee Jackson back in his coat pocket.")])]), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why? Did you think you’d bought them all?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry Dee wiped a shaky hand across his face and then dropped to the side of his bed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I paid the son of a bitch more for it than I did for the Renoir hanging in my house back in Nashville.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then I take it the blonde in the picture isn’t your wife?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry groaned beneath his breath. “No.” He grabbed Ben’s arm. “You’ve got to keep this under wraps. If my wife finds out, it’ll be the end of my marriage.” Then he covered his face with his hands. “I can’t lose my wife and kids. I love them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Should have thought of that before you got naked with another woman,” Ben said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, man,” Larry muttered, and stood abruptly. “I need a drink.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not until you answer some questions,” Ben said. “Where were you around 10:00 p.m. on December 11?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What day was that?” Larry asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Last Friday.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was in the hotel having an early night. My flight came in around 3:30 p.m. and I was tired.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can anyone vouch for that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry Dee began to sweat. “Hell, I don’t know. I had room service about six. Made a couple of calls, then watched a movie on pay-per-view.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_110"
    }
  }), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_vm._v("“Any late-night visitors, like maybe the lady in the picture?”")])]), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry Dee looked away and then shrugged. “I’m not saying.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You do know that Texas has the death penalty?” Ben asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry Dee turned pale and then shuddered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I swear to God I didn’t have anything to do with that man’s murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I need more than your word,” Ben said. “So, how about it? Did you have any visitors?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry shook his head. “Sorry, I don’t kiss and tell.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look, Jackson, the time to play gentleman would have been when you had the option of keeping your pants zipped and going home to your wife. You made a choice. Now you face the consequences. Either you tell me now, or we’ll take this discussion down to the station.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Christ almighty, Connie’s gonna kill me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben’s interest peaked. “Is this Connie capable of murder?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry looked like someone had just goosed him in the butt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh! No! Hell, no! That was just a figure of speech.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Poor choice of words,” Ben said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry Dee poured himself a generous belt of whiskey, downed it neat, and then turned to the two detectives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s Connie Marx.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_111"
    }
  }), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("Red stopped writing in the middle of a word and looked up.")])]), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('em', [_vm._v("The")]), _vm._v(" Connie Marx, WFAL anchorwoman on the evening news?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Red whistled beneath his breath and made a couple more notes as Ben shifted his line of questioning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did Miss Marx know that Charles Finelli blackmailed you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah. He got the both of us, actually. Took me for double what she had to pay, though. Said I had more to lose than she did.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Was he right?” Ben asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry sighed. “Oh, yeah.” Then he added, “What are you going to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Find a killer, Mr. Jackson.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can you keep this under wraps—I mean about the picture?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We aren’t advertising the names on this list. But if it were me, I think I’d play it safe and confess my sins to my wife and hope for the best. I’d say you have a better chance of coming out on the good side if you do that than if she reads about this mess in the papers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, man,” Larry muttered, and poured himself another drink as the detectives left.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once Ben and Red exited the hotel room where Jackson was staying, Ben slipped his notebook into his pocket and pulled out the picture of Larry and the blonde.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_112"
    }
  }), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_vm._v("“Let’s see if we can catch her at the television station and then call it a day, what do you say?” he asked.")])]), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Red nodded. “I’m all for that. I could go for a steak and a hot shower. Rita was making apple cobbler when I called her at noon. Want to come over? We can always throw another steak on the grill.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben shook his head. “No, but thanks for asking. I’m going to swing by the hospital before I head for home. I didn’t get much sleep last night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re moving into dangerous territory with her, you know that,” Red said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben started to argue, then nodded instead. “Yes, I know, but it’s too late to pull back now. I made promises to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Red frowned. “What are you going to do if you can’t keep those promises?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One thing at a time, buddy. One thing at a time. She’s alive, and for now, that’s enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("***")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("“Miss Marx, there are two detectives asking for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Connie Marx looked up from the script of the night’s broadcast and frowned. She didn’t know the short, redheaded man, but she recognized the tall one on sight. English. Ben English. He’d been the primary detective on the Whitman kidnapping last year. She stood, then went to meet them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Detective English, it’s been a while,” she said, offering him her hand.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_113"
    }
  }), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_vm._v("“Miss Marx. This is Detective Fisher, my partner. We need to ask you some questions.”")])]), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She smiled wryly. “That sounds serious. And here I thought you’d come by to invite me to the policemen’s ball.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fact that Ben didn’t return her smile was warning enough that she wasn’t going to like what they’d come to say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, what’s up?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben took the picture of her and Jackson out of his pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her expression froze as she stared in disbelief. When she looked up, her eyes were filled with fury.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t think you were the voyeuristic type,” she snapped. “Where did you get that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“From Charles Finelli’s apartment,” Ben said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That sorry, lying little bastard,” she muttered. “Someone should have shot him sooner and saved us all a lot of trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you know he’s dead,” Ben said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She rolled her eyes and then waved her script beneath his nose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I know he’s dead,” she said. “It’s what I do for a living.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where were you on December 11 at 10:00 p.m.?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Home. Nursing a case of the flu.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not what Larry Jackson said.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben could tell she was shocked. But her shock soon turned to anger, and she exploded in a fit of rage.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_vm._v("“We have nothing more to say to each other, and ")]), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_vm._v("you get the hell out of my face. I’ve got a show to do. If you have any other questions, you can contact me through my lawyer, is that understood?”")])]), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Red glanced at Ben. “Didn’t take that well, did she?” he asked as she sailed out of the room in high gear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben put the picture back in his pocket. “No, she didn’t, but it’s about what I expected of her. She’s a real bulldog. Doesn’t give an inch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Red nodded. “Would she have someone killed?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben hesitated, trying to imagine Connie Marx hiring a hit man, then shrugged. “Last month, I would have said no. But after seeing the picture, I couldn’t hazard a guess. I know that if the picture gets out, she’s probably unemployed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Would you kill to keep your job?” Red asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“People have killed for a whole lot less, and we both know it,” Ben said. “Let’s get out of here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure I can’t talk you into coming home with me tonight? Rita would love to have you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, but thanks anyway, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Red sighed. “Tell China Brown I said hello.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I will.” Then he added, “Hey, Red?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t worry, okay? Everything’s under control.”")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("***")])]), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_vm._v("Music rocked the walls inside the secluded cabin on Lake Texoma. The tall, leggy blonde sat before her mirror, putting the finishing touches on her makeup. Just a last brush of blush, then one more touch of eyeliner ")]), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_vm._v("at the corner of her left eye. When she had finished, she leaned back, giving herself a final assessment, then slowly smiled. Yes, she was beautiful, but makeup was an art, accentuating that which was already pleasing to the eye.")])]), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Honey, you are a knockout,” she murmured, then stood and danced her way to the closet and the white, beaded dress hanging on a blue silk hanger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As she lifted the dress from the hanger, she shivered in sudden ecstasy. God, but she loved the feel of silk between her fingers, and on her body—and between her legs. She stepped into the dress, then pulled it over her hips, slowly sliding her arms into the sleeves. Just the feel of that fabric against her skin turned her on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The words to the Rod Stewart classic “Da Ya Think I’m Sexy?” were her anthem. She sang along with the CD as she zipped up her dress and stepped into the matching heels.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_vm._v("A quick glance at the clock told her it wouldn’t be long before her date would be here. A shiver ran up the back of her spine as she thought about his hands touching her. God, but she loved the feel of a man’s hands on her body as much as she loved the feel of silk. It made her sick to her stomach, thinking how close she’d come to losing all of this. She had no misgivings about what she’d done to Chaz Finelli. The little bastard never did know when to quit. Besides, the game he was playing was dangerous. What happened to him was nothing more than a job hazard. She did regret having to shoot an innocent bystander, but ")]), _c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_vm._v("not enough to lose any sleep. This was a tough world, and she was as tough as they came. Survival of the fittest was her motto, and to hell with anyone who got in her way.")])]), _c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The song rocked its way to silence, and for one blessed moment she closed her eyes, savoring all that was her world. Secrets were dangerous, but danger also added another frisson of excitement to the game.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly the sound of tires rolling on gravel became apparent. She moved to the window. Although it was dark, the cat’s-eyes headlights on the sports car were a signal that her date had arrived. She’d heard about his predilection for… how could she put it? Unusual sex? All it had taken was one phone call and he was hers. Through the window, she saw him get out of the car. He paused, smoothing back his hair and brushing something from the front of his coat before moving toward the door. She smiled to herself as the doorbell began to ring. The stupid bastard. He might be rich and kinky, but before the night was over, he would know her in a very special way.")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("***")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Captain Aaron Floyd was nursing a headache and the beginnings of what felt like the flu when Detectives English and Fisher knocked on his door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Come in,” he said, and then winced at the sound of his own voice. “Give me some good news,” he said, as he opened a drawer and took out a bottle of cough medicine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“China Brown is getting better,” Ben said.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_117"
    }
  }), _c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_vm._v("“That’s good, but not the news I was referring to,” he said, then tilted the bottle to his mouth, rather than use the little plastic cup that also served as a lid. He swallowed and shuddered as he replaced the lid and put the bottle back in the drawer. “God, I hate winter and everything that comes with it.”")])]), _c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Both detectives wisely chose not to comment and waited for him to continue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay,” Floyd said. “Tell me where we are on this investigation. I’m getting some flack from up above.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Dang, Captain, you mean even God’s in on the case?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Floyd rolled his eyes and then blew his nose. “Shut up, Fisher. I don’t feel good enough to put up with your crap.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Red grinned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben leaned forward, his elbows on his knees. “We’ve been as discreet as possible without undermining our investigation. Beyond that, I don’t give a good damn. Between the adultery, the drugs and the perversions, the people involved brought it on themselves.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Amen,” Red echoed. “And what sticks in my craw is the fact that not a damn one of them even blinked about the money they paid Finelli. It was getting caught that pissed them all off.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Floyd nodded. “Yeah, but when the mayor’s involved, it puts a lot of heat on a lot of people. So, what do we know?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_vm._v("Ben handed the captain a list of names. “The ones ")]), _c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_vm._v("that aren’t crossed out are the only people who don’t have iron-clad alibis. The ones with a red mark beside them are the ones who have no one to corroborate where they were. The others had people who could vouch for them part of the night, but not all of it.”")])]), _c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Floyd scanned the list. “Ariel Simmons? Wasn’t she on television that night?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Taped show,” Red said. “Which she forgot to mention when we asked.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Floyd moved to the next name. “Connie Marx?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Said she was home with the flu,” Ben offered. “Turns out Larry Dee Jackson says she was in his hotel room with him. Either way, one of them is lying, maybe both.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about Bo Milam, the real estate developer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In a jet on his way to Las Vegas. It checked out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And the others?” Floyd asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“About the same story, but we’re still working on these two.” Red pointed to the bottom of the page. “One’s a banker. One’s a plastic surgeon. Neither one has an alibi worth a damn, and we’ve got a couple of guys checking them out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Floyd looked up. “Okay, keep at it,” he said. “Let me know as soon as something breaks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Captain, about the guard we put on China Brown…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about it?” Floyd asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d like to continue it 24-7 until we know who we’re looking for. If word gets out that we’ve got a live witness to this, her life won’t be worth a damn.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_119"
    }
  }), _c('a', {
    attrs: {
      "id": "page_120"
    }
  }, [_vm._v("“How are you handling that, by the way?” Floyd asked.")])]), _c('a', {
    attrs: {
      "id": "page_120"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“With a little deception. The newspaper account said two people were killed. Finelli and someone whose name wasn’t being released until notification of kin. We’re counting on the shooter to assume that China was the other death, since she’s the one who got shot. The fact that it was her child instead of her might not occur to him, and as long as he thinks she’s dead, she’s safe.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, I’ll back you on this,” Floyd said. “Continue the guard. But after she’s released, that’s another story. She was homeless, right? We don’t have the budget to put her up in a hotel with round-the-clock guards until we bring in the perp.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben was already ahead of the issue. “There won’t be any problems. I’m taking her home with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Floyd forgot the headache and every other ache in his body as he bolted up out of his seat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The hell you will,” he said. “You’re already over the line with this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not planning to kidnap her. I’m just offering her a safe place to stay.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s a conflict of interest. I won’t allow it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben stood his ground. “I’m not a lawyer. I’m a cop. What I do on my own time is my business as long as it’s not illegal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t like it,” Floyd said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Objection noted,” Ben said. “Is there anything else?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_120"
    }
  }), _c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_vm._v("Floyd glared at Ben English. Ben returned the stare without comment. Floyd was the first to look away.")])]), _c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mess this up and I’ll have your ass,” he warned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s already messed up, Captain. I’m just trying to do something right. It’s the least she deserves.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then go catch me a killer,” Floyd said.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec2ebf4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/chapter6.vue
// module id = 99
// module chunks = 0